import { ToastContainer } from "react-toastify";
import "./App.scss";
import Routes from "./routes";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <Routes />
      <ToastContainer />
    </Router>
  );
}

export default App;
